module.exports = __webpack_public_path__ + "static/media/success-icon.d5875f81.svg";